todays-index
  .tasks-wrap
    .task(each="{task_id in opts.tasks}")
      orders-today(tag-scope="{ dataScopeOrder(getTaskData(task_id).order_id) }" phase-id="{ getTaskData(task_id).phase_id }")
      .mb-4
      tasks-today(tag-scope="{dataScopeTask(task_id)}")
      orders-planner-lines(tag-scope="{ dataScopeOrder(getTaskData(task_id).order_id) }" data-edit="{false}")
    orders-planner-dialog-tooltip-schedule(tag-scope="orders_planner_dialog_tooltip_schedule")
    orders-planner-scroll(tag-scope="{orders_planner}")
  script(type="typescript").
    this.mixin('todays.index');
  style(scoped).
    .task {
      margin-bottom: 150px;
    }
